module.exports = __webpack_public_path__ + "static/media/XL.2982eccd.jpg";